module.exports = __webpack_public_path__ + "img/claire_wed.1241c1fd.jpg";